import { api } from 'repositories/api';
import { UserExistsModel } from 'models';

export interface VerifyEmailExistsResult {
    success: boolean;
    userExists?: boolean;
    error?: any;
}

export function* verifyEmailExistsSaga(email: string): Generator<any, VerifyEmailExistsResult, any> {
    try {
        const userExistsModel: UserExistsModel = yield api.hybris.checkEmail(email);

        return { success: true, userExists: userExistsModel.userExists };
    } catch (error) {
        return { success: false, error };
    }
}
